import { Import } from '../@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetImportStatusByIdRequest = {
	importId: number;
	latest?: number;
};

export type GetImportStatusByIdResponse = Import;

export const getImportStatusById = createGetEndpoint<GetImportStatusByIdRequest, GetImportStatusByIdResponse>(
	(request) => `/api/v3/core/imports/${request?.importId}/status?${getQueryString({ latest: request?.latest })}`
);
